import Vue from 'vue'

export default function setTeacherMissing({ teacher, missings }) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/teachers/" + teacher.id + "/missing"
    return Vue.http
        .post(url, missings, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json()).catch(() => { throw "Ошибка сохранения" })
}